export default __webpack_public_path__ + "7fdfe3ecffb23e389e350133133826c5.png";